import environmentSlice from './environmentSlice';

const configSlices = [environmentSlice];

export default configSlices;
